import { UtilityService } from './index'

class SystemService {


    async getSystemInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getPage', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                type: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async listSystemSuppliers(page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/SystemSuppliers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //for add and edit systemSupplier
    async SystemSupplier(supplierData) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/AddSystemSuppliers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(supplierData)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async viewystemSupplier(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/SystemSupplier', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async removeSystemSupplier(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/SystemSuppliers', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }


    async listCategoryContent(value, heading, moduleSystem, page) {

        let api = moduleSystem === "costings" ? UtilityService.baseUrl() + `api/system/getCostingSystem`
            :
            moduleSystem === "embroiderys" ?

                UtilityService.baseUrl() + `api/system/SystemEmbroideries`
                :
                moduleSystem !== "trims" ?

                    UtilityService.baseUrl() + `api/system/System${moduleSystem}`
                    :
                    UtilityService.baseUrl() + `api/system/System${moduleSystem}`

        const method = moduleSystem === "general" ? "GET" : "POST"
        let result = await fetch(api, {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: heading,
                subHeading: value,
                page: page,
            })
        });
        return result.json();
    }

    async getSupplierPart(moduleName) {

        let api = UtilityService.baseUrl() + `api/system/System${moduleName}`
        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "heading": "SUPPLIER",
                "subHeading": "SUPPLIERPART",
            })
        });
        return result.json();
    }

    async getSpecificTrimCategory(id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/getSpecificTrim', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }
    async addCategory(value, categoryName, subModule, systemModule, price, supplierData, id, moduleName, number) {

        let api = systemModule === "COSTING" ? UtilityService.baseUrl() + `api/system/addSystemCosting`
            : systemModule === "EMBROIDERY" ? UtilityService.baseUrl() + `api/system/AddSystemEmbroideries`
                : categoryName === "SUPPLIERPART" ? UtilityService.baseUrl() + `api/system/AddSystem${systemModule}`
                    : systemModule !== "TRIMS" ? UtilityService.baseUrl() + `api/system/AddSystem${systemModule.toLowerCase()}s`
                        : UtilityService.baseUrl() + `api/system/AddSystem${systemModule}`

        let jsonData = {
            heading: subModule,
            subHeading: categoryName,
        }
        if (categoryName === 'ASSIGNEDTO') {
            jsonData.assignedTo = value
        }
        else {
            jsonData.name = value
        }

        if (supplierData && moduleName) {
            jsonData = { ...jsonData, ...supplierData, moduleName: moduleName }
        }
        if (id) {
            jsonData._id = id
        }

        jsonData.price = price != undefined || price === "" ? price : null
        if (number) {
            jsonData.number = number
        }
        console.log(jsonData);

        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(jsonData)
        });
        return result.json();
    }

    async editCategoryForCad(value, id, moduleName, categoryName) {
        let api = UtilityService.baseUrl() + `api/system/AddSystemcads`
        let jsonData = {
            _id: id,
        }
        jsonData.name = value

        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(jsonData)
        });
        return result.json();
    }

    async addCategoryForPortofpickup(value, categoryName, subModule, systemModule) {

        let api = systemModule === "COSTING" ? UtilityService.baseUrl() + `api/system/addSystemCosting`
            : systemModule === "EMBROIDERY" ? UtilityService.baseUrl() + `api/system/AddSystemEmbroideries`
                : systemModule !== "TRIMS" ? UtilityService.baseUrl() + `api/system/AddSystem${systemModule.toLowerCase()}s`
                    : UtilityService.baseUrl() + `api/system/AddSystem${systemModule}`

        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value.portofpickup,
                freightCostAbove500: value.freightCostAbove500,
                freightCostBelow500: value.freightCostBelow500,
                seaFreightCost: value.seaFreightCost,
            })
        });
        return result.json();
    }


    async editCategoryForPortofpickup(value, categoryName, subModule, id) {
        let api = UtilityService.baseUrl() + `api/system/AddSystemfabrics`
        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value.portofpickup,
                freightCostAbove500: value.freightCostAbove500,
                freightCostBelow500: value.freightCostBelow500,
                seaFreightCost: value.seaFreightCost,
                _id: id
            })
        });
        return result.json();
    }

    async addCategoryForTrimPack(value, categoryName, subModule, systemModule) {

        let api = systemModule === "COSTING" ? UtilityService.baseUrl() + `api/system/addSystemCosting`
            : systemModule === "EMBROIDERY" ? UtilityService.baseUrl() + `api/system/AddSystemEmbroideries`
                : systemModule !== "TRIMS" ? UtilityService.baseUrl() + `api/system/AddSystem${systemModule.toLowerCase()}s`
                    : UtilityService.baseUrl() + `api/system/AddSystem${systemModule}`

        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value.packingMaterialType,
            })
        });
        return result.json();
    }

    async editCategoryForTrimPack(value, categoryName, subModule, id) {
        let api = UtilityService.baseUrl() + `api/system/AddSystemcustomers`
        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value.packingMaterialType,
                _id: id
            })
        });
        return result.json();
    }

    //edit api
    async getDataById(id, heading) {
        let api = UtilityService.baseUrl() + `api/system/getSystemDataById`

        let result = await fetch(api, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                systemType: heading,
            })
        });
        return result.json();
    }


    async addCategoryForTrimCat(value, trimRef, categoryName, units, status, subModuleName) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/AddSystemTrims', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                name: value,
                referNo: trimRef,
                unit: units,
                status: status,
            })
        });
        return result.json();
    }

    // done by viswa
    async addCategoryToParentTrim(value, categoryName, subModuleName) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/AddSystemTrims', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                name: value,
            })
        });
        return result.json();
    }


    async addCategoryForCurrency(value, currencyValue, currency, categoryName, subModule) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/AddSystemCustomers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value,
                currency: currency,
                currencyValue: parseInt(currencyValue),
            })
        });
        return result.json();
    }

    async addCategoryForMachine(categoryValue, needleCode, factor, needle, looper, subModuleName, overLock, trimThread, sheeringNeedle) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/addSystemStyles`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: "MACHINE",
                name: categoryValue,
                needleCode: needleCode,
                factor: factor,
                needle: needle,
                looper: looper,
                overLock: overLock,
                trimThread: trimThread,
                sheeringNeedle: sheeringNeedle
            })
        });
        return result.json();
    }
    async addCategoryForCity(value, categoryName, country, subModuleName) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/AddSystemCustomers`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                name: value,
                country: country
            })
        });
        return result.json();
    }

    async addCategoryForBackingType(value, categoryName, subModuleName, typeMultiple) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/AddSystemsamplerequests`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                name: value,
                typeMultiple: typeMultiple
            })
        });
        return result.json();
    }

    async addCategoryForSmockingSheering(value) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/AddSystemsamplerequests`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: 'TRIM',
                subHeading: "SHIRRINGORSMOCKING",
                name: 'dummy',
                ...value
            })
        });
        return result.json();
    }

    async getCategoryForSmockingSheering() {
        let result = await fetch(UtilityService.baseUrl() + `api/system/Systemsamplerequest`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                subHeading: "SHIRRINGORSMOCKING",
            })
        });
        return result.json();
    }

    async editCategoryForBackingType(value, _id, categoryName, subModuleName, typeMultiple) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/AddSystemsamplerequests`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                // heading: subModuleName,
                // subHeading: categoryName,
                name: value,
                typeMultiple: typeMultiple,
                _id: _id
            })
        });
        return result.json();
    }

    async addSampleRequestType(categoryName, id, subModuleName) {
        let result = await fetch(UtilityService.baseUrl() + `api/system/setDefaultEmp`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                employeeId: id

            })
        });
        return result.json();
    }
    async editCategoryForCity(value, country, id) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/editSystemCustomers`, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                name: value,
                country: country
            })
        });
        return result.json();
    }

    async addCategoryForAddress(country, city, address, categoryName, subModuleName) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/AddSystemCustomers`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                name: address,
                city: city,
                country: country
            })
        });
        return result.json();
    }
    async editCategoryForAddress(categoryInfo, categoryName, id, subModuleName) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/editSystemCustomers`, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                _id: id,
                subHeading: categoryInfo,
                name: categoryName !== undefined && categoryName.categoryName,
                city: categoryName !== undefined && categoryName.categoryFull !== undefined && categoryName.categoryFull.city !== undefined && categoryName.categoryFull.city !== undefined && categoryName.categoryFull.city._id,
                country: categoryName !== undefined && categoryName.countryId
            })
        });
        return result.json();
    }


    async editCategoryForMachine(id, categoryValue, needleCode, factor, needle, looper, subModuleName, overLock, trimThread, sheeringNeedle) {

        let result = await fetch(UtilityService.baseUrl() + `api/system/editSystemStyles`, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                heading: subModuleName,
                subHeading: "MACHINE",
                name: categoryValue,
                needleCode: needleCode,
                factor: factor,
                needle: needle,
                looper: looper,
                overLock: overLock,
                trimThread: trimThread,
                sheeringNeedle: sheeringNeedle
            })
        });
        return result.json();
    }

    async editCategory(value, id, moduleName, categoryName, price, number) {
        let api = moduleName === "embroidery" ?
            UtilityService.baseUrl() + `api/system/editSystemEmbroideries` : moduleName == "samplerequest" ? UtilityService.baseUrl() + 'api/system/AddSystemsamplerequests'
                : moduleName !== "trims" ? UtilityService.baseUrl() + `api/system/editSystem${moduleName}s` : UtilityService.baseUrl() + `api/system/editSystem${moduleName}`

        let jsonData = {
            _id: id,
        }
        if (categoryName === 'ASSIGNEDTO') {
            jsonData.assignedTo = value
        } else {
            jsonData.name = value
        }
        if (price != "" || price != undefined) {
            jsonData.price = price
        }
        if (number) {
            jsonData.number = number
        }
        console.log(jsonData);


        let result = await fetch(api, {
            method: moduleName == "samplerequest" ? "POST" : "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(jsonData)
        });
        return result.json();
    }

    async editCategoryForTrimCat(value, trimRef, categoryName, units, status, id, subModuleName) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/editSystemTrims', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModuleName,
                subHeading: categoryName,
                name: value,
                referNo: trimRef,
                unit: units,
                status: status,
                _id: id
            })
        });
        return result.json();
    }

    async editCategoryForCurrency(value, currencyValue, currency, categoryName, subModule, id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/EditSystemCustomers', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value,
                currency: currency,
                currencyValue: parseInt(currencyValue),
                _id: id
            })
        });
        return result.json();
    }

    async removeSystemCategory(id, subModuleName) {
        let api =
            subModuleName == "SAMPLEREQUEST" ? UtilityService.baseUrl() + `api/system/deleteSystemSampleRequest` :
                subModuleName !== "TRIMS" ? UtilityService.baseUrl() + `api/system/System${subModuleName}` :
                    UtilityService.baseUrl() + `api/system/SystemTrim`
        let result = await fetch(api, {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }

    async editCategoryForCurrency(value, currencyValue, currency, categoryName, subModule, id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/system/EditSystemCustomers', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: subModule,
                subHeading: categoryName,
                name: value,
                currency: currency,
                currencyValue: parseInt(currencyValue),
                _id: id
            })
        });
        return result.json();
    }

    //get All system fabrics
    async getCountryList() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getAllSystemCountry', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async smvOthers(heading, subHeading, wastage, otherSize, wash, _id) {
        let obj = {}
        obj.heading = heading
        obj.subHeading = subHeading
        obj.wastage = wastage
        obj.wash = wash
        obj.otherSize = otherSize
        if (_id !== "") {
            obj._id = _id
        }
        let result = await fetch(UtilityService.baseUrl() + 'api/system/addSMVStyle', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(obj)
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async getSmvOthers() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getSysSMVOthers', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    // currency conversion

    async currencyConversion(heading, subHeading, usd, gbp, eur, _id) {
        let obj = {}
        obj.heading = heading
        obj.subHeading = subHeading
        obj.usd = usd
        obj.gbp = gbp
        obj.eur = eur
        if (_id !== "") {
            obj._id = _id
        }
        let result = await fetch(UtilityService.baseUrl() + 'api/system/addCurrencyConversion', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(obj)
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async costingOthers(heading, subHeading, valueLoss, overHeads, conversionRate, freightCharges, processingCost, duty, orderQty, costPertailor, noOftailors, perMachine, idleDays, _id) {
        let obj = {}
        obj.heading = heading
        obj.subHeading = subHeading
        obj.valueLoss = valueLoss
        obj.overHeads = overHeads
        obj.conversionRate = conversionRate
        obj.freightCharges = freightCharges
        obj.processingCost = processingCost
        obj.orderQty = orderQty
        obj.duty = duty
        obj.costPertailor = costPertailor
        obj.noOftailors = noOftailors
        obj.perMachine = perMachine
        obj.idleDays = idleDays
        if (_id !== "") {
            obj._id = _id
        }
        let result = await fetch(UtilityService.baseUrl() + 'api/system/addcostingOthers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(obj)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async editGstValue(gst){
        let obj = {}
        obj.gst = gst
        let result = await fetch(UtilityService.baseUrl() + 'api/system/addGST',{
            method:"POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(obj)
        });
        return{
            status: result.status,
            text: await result.json()
        }
    }

    async getcurrencyConversion() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getcurrencyConversion', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getGstValue() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getGST',{
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        }
    }

    //costing others
    async getCostingOthers() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getCostingOthers', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

}

export default new SystemService();


// WEBPACK FOOTER //
// ./src/services/system.service.js